module.exports = __webpack_public_path__ + "img/20191022_122025.383faf8c.jpg";